/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_MadeInputs */

const en_footer_made = /** @type {(inputs: Footer_MadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexxt · TLG × Tomorrow`)
};

/**
* | output |
* | --- |
* | "Nexxt · TLG × Tomorrow" |
*
* @param {Footer_MadeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const footer_made = /** @type {((inputs?: Footer_MadeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_MadeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_footer_made(inputs)
});